var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDcm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ef8mu8uu1a",
    d: "M4 0h24c2.21 0 4 1.79 4 4v24c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-179 -592) translate(179 592)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#EDF2F8",
    opacity: 0.8,
    xlinkHref: "#ef8mu8uu1a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#012B46",
    d: "M2.4 0h16.8c1.325 0 2.4 1.075 2.4 2.4v4.8c0 1.325-1.075 2.4-2.4 2.4H2.4C1.075 9.6 0 8.525 0 7.2V2.4C0 1.075 1.075 0 2.4 0z",
    transform: "translate(-179 -592) translate(179 592) translate(5 19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M4.43 7.5c1.661 0 2.668-1.028 2.668-2.733 0-1.699-1.007-2.722-2.653-2.722h-1.95V7.5H4.43zm-.048-.988h-.733V3.034h.735c1.023 0 1.564.522 1.564 1.733 0 1.218-.541 1.745-1.566 1.745zm6.013 1.063c1.399 0 2.243-.93 2.368-1.934l-1.166-.005c-.11.583-.568.919-1.183.919-.828 0-1.39-.616-1.39-1.782 0-1.135.554-1.782 1.398-1.782.631 0 1.087.365 1.175.964h1.166c-.152-1.26-1.105-1.984-2.368-1.984-1.44 0-2.54 1.017-2.54 2.802 0 1.779 1.08 2.802 2.54 2.802zM14.71 7.5V3.936h.045l1.412 3.537h.762L18.34 3.95h.045V7.5h1.12V2.045h-1.423L16.58 5.71h-.064l-1.502-3.665H13.59V7.5h1.119z",
    transform: "translate(-179 -592) translate(179 592) translate(5 19)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#59709B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14-.5c.69 0 1.315.28 1.768.732C16.22.685 16.5 1.31 16.5 2h0v7c0 .69-.28 1.315-.732 1.768-.453.452-1.078.732-1.768.732h0H2c-.69 0-1.315-.28-1.768-.732C-.22 10.315-.5 9.69-.5 9h0V2c0-.69.28-1.315.732-1.768C.685-.22 1.31-.5 2-.5h0z",
    transform: "translate(-179 -592) translate(179 592) translate(8 5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M7 2.5L8.911 2.5M7 6.591L8.911 6.591M6 4.59h.978m1.955 0h.978M8 1.587L8 7.678M9.09 6.591L9.591 6.591 9.591 8.891",
    transform: "translate(-179 -592) translate(179 592) translate(8 5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M6.404 6.591L6.91 6.591 6.91 8.891",
    transform: "translate(-179 -592) translate(179 592) translate(8 5) matrix(-1 0 0 1 13.313 0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDcm);
export default __webpack_public_path__ + "static/media/ic-dcm.2945f3a8ddb283d5440bc72b3bb38eaa.svg";
export { ForwardRef as ReactComponent };